import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { Spinner } from './components/ui/primitives';
import { NotFoundPage } from './pages/NotFoundPage';

const HomePage = lazy(() => import('./pages/HomePage'));
const LobbyPage = lazy(() => import('./pages/LobbyPage'));
const GamePage = lazy(() => import('./pages/GamePage'));
const PromotionsPage = lazy(() => import('./pages/PromotionsPage'));
const VipPage = lazy(() => import('./pages/VipPage'));
const WalletPage = lazy(() => import('./pages/WalletPage'));
const AccountPage = lazy(() => import('./pages/AccountPage'));
const ResponsibleGamingPage = lazy(() => import('./pages/ResponsibleGamingPage'));
const HelpPage = lazy(() => import('./pages/HelpPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const AuthPage = lazy(() => import('./pages/AuthPage'));

function PageFallback() {
  return (
    <div className="grid min-h-[60vh] place-items-center">
      <Spinner className="size-8" />
    </div>
  );
}

const wrap = (node: ReactNode) => <Suspense fallback={<PageFallback />}>{node}</Suspense>;

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: wrap(<HomePage />) },
      { path: 'casino', element: wrap(<LobbyPage />) },
      { path: 'casino/:category', element: wrap(<LobbyPage />) },
      { path: 'games/:gameId', element: wrap(<GamePage />) },
      { path: 'promotions', element: wrap(<PromotionsPage />) },
      { path: 'vip', element: wrap(<VipPage />) },
      { path: 'wallet', element: wrap(<WalletPage />) },
      { path: 'account', element: wrap(<AccountPage />) },
      { path: 'responsible-gaming', element: wrap(<ResponsibleGamingPage />) },
      { path: 'help', element: wrap(<HelpPage />) },
      { path: 'legal/:slug', element: wrap(<LegalPage />) },
      { path: 'login', element: wrap(<AuthPage mode="login" />) },
      { path: 'register', element: wrap(<AuthPage mode="register" />) },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
